module.exports = __webpack_public_path__ + "static/footer-slider-60f0d7211cc1ed6ffca566a946227e33.jpg";